// src/components/Dashboard/RoleDashboard/RoleDashboardLayout.jsx
import React, { useLayoutEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

export default function RoleDashboardLayout({ dashboardGrid }) {
    const location = useLocation();
    const path = (location.pathname || "").replace(/\/+$/, "");

    /**
     * ✅ IMPORTANT:
     * /<role>-dashboard/video-profiles should NOT hide the dashboard grid
     * because we want to keep the SAME VideoProfile instance mounted (no refresh).
     */
    const isVideoProfiles = path.endsWith("/video-profiles");

    // ✅ FULL PAGE outlet pages
    const isVideoProfilePage = path.includes("/video-profile/");

    // ✅ Detect public role profile pages (View Profile)
    const isRoleProfilePage =
        path.includes("/agent-profile/") ||
        path.includes("/scout-profile/") ||
        path.includes("/club-profile/");

    // ✅ Detect nested player profile page inside dashboard
    const isPlayerProfilePage = path.includes("/player-profile/");

    /**
     * ✅ Fullscreen rule (Outlet-only):
     * Show ONLY the Outlet page and hide the dashboard grid.
     */
    const isFullscreenPage =
        // ✅ Feed page fullscreen
        path.endsWith("/feed") ||

        isVideoProfilePage ||
        isRoleProfilePage ||
        isPlayerProfilePage ||
        path.endsWith("/chats") ||
        path.endsWith("/notifications") || // ✅ Notifications full page
        path.endsWith("/report") ||
        path.endsWith("/vsn-world") ||
        path.endsWith("/contract-offer") ||
        path.endsWith("/manage-contract") ||
        path.endsWith("/show-interest") ||
        path.endsWith("/view-posts") ||
        path.endsWith("/view-applications") ||
        path.endsWith("/bookmarks") ||
        path.includes("/offer-to-sign/");

    /* -----------------------------------------------------
       Canvas background control
       Yellow for dashboard pages
       Black for fullscreen pages
    ------------------------------------------------------*/
    useLayoutEffect(() => {
        const prevBodyBg = document.body.style.backgroundColor;
        const prevHtmlBg = document.documentElement.style.backgroundColor;

        // ✅ Background behind everything
        const bg = isFullscreenPage ? "#000000" : "#FFFF00";
        document.body.style.backgroundColor = bg;
        document.documentElement.style.backgroundColor = bg;

        // ✅ This class lets CSS override the dashboard wrapper background
        document.body.classList.toggle("role-fullscreen", isFullscreenPage);

        return () => {
            document.body.style.backgroundColor = prevBodyBg || "";
            document.documentElement.style.backgroundColor = prevHtmlBg || "";
            document.body.classList.remove("role-fullscreen");
        };
    }, [path, isFullscreenPage]);

    return (
        <>
            {/* ✅ Keep mounted; hide ONLY on fullscreen outlet pages */}
            <div
                className={`dashboard-grid-shell ${isFullscreenPage ? "is-hidden" : ""}`}
            >
                {dashboardGrid}
            </div>

            {/* ✅ Child pages render here */}
            <Outlet />
        </>
    );
}















